export const YEARS = [2019, 2018];

export const YEARS_ACCOMODATION = [2022, 2019, 2018];

export const YEARS_SICK = [2021];

export const YEARS_OSETROVNE = [2020, 2019, 2018];

export const EMPLOYER_COMPENSATION_REDUCTION_THRESHOLD = {
	/*
	Bcs. we are calculating in 8 workhours day, we need to recalculate to workdays
	206.85 per workhour = 1654.8 per workday
	310.28 per workhour = 2482.24 per workday
	620.38 per workhour = 4963.04 per workday
	*/
	'2021': [1654.8, 2482.24, 4963.04],
};

export const EMPLOYER_COMPENSATION_REDUCTION_MULTIPLIERS = {
	'2021': [0.9, 0.6, 0.3],
};

export const EMPLOYER_COMPENSATION_FINAL_REDUCTION = {
	'2021': 0.6,
};

export const SOCIAL_INSURANCE_REDUCTION_THRESHOLD = {
	'2018': [1000, 1499, 2998],
	'2019': [1090, 1635, 3270],
	'2020': [1162, 1742, 3484],
	'2021': [1182, 1773, 3545],
};

export const SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS = {
	'2018': [0.9, 0.6, 0.3],
	'2019': [0.9, 0.6, 0.3],
	'2020': [0.9, 0.6, 0.3],
	'2021': [0.9, 0.6, 0.3],
};

export const SOCIAL_INSURANCE_REDUCTION_MULTIPLIERS_CHILDCARE = {
	'2018': [1, 0.6, 0.3],
	'2019': [1, 0.6, 0.3],
	'2020': [1, 0.6, 0.3],
};

export const SOCIAL_INSURANCE_CHILDCARE_TOTAL_AMOUNT = {
	'2018': [220000, 330000],
	'2019': [220000, 330000],
	'2020': [300000, 450000],
};

export const SICKNESS_INSURANCE_MINIMUM_PAYMENT = {
	'2018': 115,
	'2019': 138,
	'2021': 147,
};

export const SICKNESS_INSURANCE_MAXIMUM_PAYMENT = {
	'2018': 2485,
	'2019': 2759,
	'2021': 2978,
};

export const LIVING_MINIMUM = {
	'2018': {
		SINGLE: 3410,
		FIRST_ADULT: 3140,
		OTHER_ADULT: 2830,
		CHILDREN: [1740, 2140, 2450],
	},
	'2019': {
		SINGLE: 3410,
		FIRST_ADULT: 3140,
		OTHER_ADULT: 2830,
		CHILDREN: [1740, 2140, 2450],
	},
	'2020': {
		SINGLE: 3860,
		FIRST_ADULT: 3550,
		OTHER_ADULT: 3200,
		CHILDREN: [1970, 2420, 2770],
	},
	'2021': {
		SINGLE: 3860,
		FIRST_ADULT: 3550,
		OTHER_ADULT: 3200,
		CHILDREN: [1970, 2420, 2770],
	},
};

export const CHILD_ALLOWANCE = {
	'2020': {
		base: [500, 610, 700],
		increasedBy: 300,
		livingMinimumThreshold: 2.7,
	},
	'2021': {
		base: [630, 770, 880],
		increasedBy: 500,
		livingMinimumThreshold: 3.4,
	},
};

export const YEARS_CHILD_ALLOWANCE = Object.keys(CHILD_ALLOWANCE).sort((a, b) => b - a);

// Wage compensation reduction thresholds are 17.5 % of Social insurance reduction thresholds
export const WAGE_COMPENSATION_REDUCTION_THRESHOLD = {
	'2018': SOCIAL_INSURANCE_REDUCTION_THRESHOLD[2018].map(t => t * 0.175),
	'2019': SOCIAL_INSURANCE_REDUCTION_THRESHOLD[2019].map(t => t * 0.175),
	'2020': SOCIAL_INSURANCE_REDUCTION_THRESHOLD[2020].map(t => t * 0.175),
};

export const HOUSING_ALLOWANCE_WITH_RENT = {
	'2018': {
		'1': [7870, 6227, 5928, 5036, 4844],
		'2': [11186, 8938, 8530, 7308, 7046],
		'3': [15116, 12176, 11642, 10045, 9702],
		'4': [18827, 15282, 14639, 12712, 12299],
	},
	'2019': {
		'1': [8233, 6541, 6233, 5314, 5117],
		'2': [11444, 9129, 8708, 7450, 7180],
		'3': [15288, 12260, 11710, 10065, 9712],
		'4': [18805, 15154, 14491, 12507, 12082],
	},
	'2022': {
		'1': [14621, 12771, 12435, 11429, 11246],
		'2': [18129, 15597, 15137, 13761, 13510],
		'3': [20812, 17500, 16899, 15099, 14771],
		'4': [24995, 21002, 20277, 18106, 17711],
	},
};

export const HOUSING_ALLOWANCE_FOR_OWNERS = {
	'2018': {
		'1': [4420, 4420, 4420, 4420, 4420],
		'2': [6489, 6489, 6489, 6489, 6489],
		'3': [8939, 8939, 8939, 8939, 8939],
		'4': [11298, 11298, 11298, 11298, 11298],
	},
	'2019': {
		'1': [4670, 4670, 4670, 4670, 4670],
		'2': [6661, 6661, 6661, 6661, 6661],
		'3': [9050, 9050, 9050, 9050, 9050],
		'4': [11268, 11268, 11268, 11268, 11268],
	},
	'2022': {
		'1': [8732, 8732, 8732, 8732, 8732],
		'2': [10932, 10932, 10932, 10932, 10932],
		'3': [13561, 13561, 13561, 13561, 13561],
		'4': [16368, 16368, 16368, 16368, 16368],
	},
};

export const HOUSING_ALLOWANCE_LIMIT = 0.3;
export const HOUSING_ALLOWANCE_LIMIT_PRAGUE = 0.35;

export const PPM_DURATION = {
	ONE_CHILD: 196,
	MORE_CHILDREN: 259,
};

export const ALIMONY_CONSTANTS = {
	min: [0.11, 0.13, 0.15, 0.16, 0.19],
	max: [0.15, 0.17, 0.19, 0.22, 0.25],
};
